import { Node_Type } from "./../ricos-schema/legacy/wix/rich_content/v1/index.js";
const dividerConverter = {
  toPm: {
    types: [Node_Type.DIVIDER],
    // @ts-expect-error next node type
    convert: (node) => ({
      type: Node_Type.DIVIDER,
      attrs: {
        ...node.dividerData,
        id: node.id
      }
    })
  },
  fromPm: {
    types: [Node_Type.DIVIDER],
    // @ts-expect-error next node type
    convert: (node) => {
      const { id, ...data } = node.attrs || {};
      return {
        type: Node_Type.DIVIDER,
        id,
        nodes: [],
        dividerData: {
          ...data
        }
      };
    }
  }
};
export {
  dividerConverter
};
//# sourceMappingURL=divider-converter.js.map
